import { scan } from "@pdfking/rfunc"
import Icon from "@pdfking/workflow/components/Icon"
import make_translations from "@pdfking/workflow/utils/make_translations"
import { defineComponent } from "vue"
import toggle_class from "../dom/toggle_class"
import state from "../state/main"
import persistence from "../utils/persistence"

export default defineComponent({
  computed: {
    is_collapsed() {
      return !this.expanded && this.needs_collapse
    },
    translations: () => make_translations("actions"),
  },
  data() {
    const store = this.persist
      ? persistence(`collapsable-${this.persist}`)
      : null

    return {
      expanded: false,
      max_height: this.height || 300,
      needs_collapse: false,
      store,
    }
  },

  methods: {
    toggle() {
      const expanded = !this.expanded
      this.store?.set(expanded)
      this.expanded = expanded
      if (!expanded) (state as any).track_event("button_expand", "expand")
    },
  },
  mounted() {
    this.store?.get().then((v: boolean) => (this.expanded = v))

    this.$nextTick(() => {
      this.needs_collapse =
        (this.$refs.text as HTMLElement).clientHeight > this.max_height

      if (this.needs_collapse && this.selector)
        scan(
          (el: HTMLElement) =>
            el.addEventListener("click", (e: Event) => {
              e.preventDefault()
              e.stopPropagation()
              this.toggle()
            }),
          toggle_class(this.selector, {
            [this.add]: true,
            [this.remove]: false,
          })
        )
    })
  },
  props: [
    "content",
    "height",
    "link",
    "selector",
    "remove",
    "add",
    "persist",
  ] as const,
  render() {
    return (
      <div class="text-collapsable">
        <div
          ref="text"
          class={[
            "text-content",
            { "text-collapsed": this.is_collapsed && this.needs_collapse },
          ]}
          style={{
            "max-height": this.is_collapsed ? `${this.max_height}px` : null,
          }}
          innerHTML={this.content}
        />
        {this.needs_collapse && !this.selector && (
          <div class={this.link ? "text-start pt-0" : "text-center pt-3"}>
            <a
              class={this.link ? "text-muted small" : "btn btn-outline-light"}
              href="#"
              onClick={(e: Event) => {
                e.preventDefault()
                e.stopPropagation()
                this.toggle()
              }}
            >
              {this.expanded
                ? this.translations.actions.HIDE
                : this.translations.actions.SHOW_ALL}
              <Icon name="ARROW_RIGHT" />
            </a>
          </div>
        )}
      </div>
    )
  },
})
